module.exports = __webpack_public_path__ + "static/media/default-complete-success.02c3e606.jpg";